import { useUserMetadata } from "lib/store/user"
import { pageNames } from "plugins/Paywall/paywall-constants"
import { BaseContactPage } from "plugins/Paywall/pages/BaseContactPage"

export function SubscriptionContactPage({ setPage }) {
    const userMeta = useUserMetadata() || {}
    if (!userMeta) return null

    const displayName = userMeta.displayName ?? ""
    const email = userMeta.email ?? ""

    const subject = "Interest in a SFG20 Facilities-iQ Subscription"
    const title = "Contact us to discuss a Subscription"
    const description =
        "Get in touch with one of our experts today to discover how SFG20 can help your team's facilities management needs."
    const onBack = () => setPage(pageNames.licenceSelect)

    const message = `Hello,<br />Please contact me to discuss a SFG20 Facilities-iQ Subscription.<br />Regards,<br />${displayName}${email ? `<br />${email}` : ""}`

    return (
        <BaseContactPage formContents={{ subject, message }} title={title} description={description} onBack={onBack} />
    )
}
